import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global ResizeObserver error suppression
const resizeObserverErrorHandler = (e: ErrorEvent) => {
  if (e.message && e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
  return true;
};

// Suppress ResizeObserver errors globally
window.addEventListener('error', resizeObserverErrorHandler, true);

// Also suppress unhandled promise rejections for ResizeObserver
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && typeof e.reason === 'string' && e.reason.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.preventDefault();
  }
});

// Override console.error to suppress ResizeObserver errors
const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args[0];
  if (typeof message === 'string' && message.includes('ResizeObserver loop completed with undelivered notifications')) {
    return; // Suppress this specific error
  }
  originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
